// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"825e0fe7","560":"aad110f7","703":"b46492e2","787":"78848a4c"}[chunkId] + ".chunk.js";
};